import { Setting } from '../utility/Setting';

/**
 * ヘッダー
 */
export class Header {
  /**
   * コンストラクタ
   * @param element 対象の要素セレクタ
   * @param option オプション
   */
  constructor(element: string, option: HeaderOption = {
    openBtnName: 'header__switch',
    menuName: 'header__nav',
    layerName: 'header__layer',
    breakPoint: Setting.headerBreakPoint
  }) {
    $(element).each((index: number, element: HTMLElement): void => {
      const $this: JQuery = $(element);
      $this.data('header', new HeaderObject($this, option));
    });
  }
}

/**
 * オプション
 */
export interface HeaderOption {
  /**
   * 開くボタンのセレクタ
   */
  openBtnName: string;

  /**
   * メニューのセレクタ
   */
  menuName: string;

  /**
   * レイヤーのセレクタ
   */
  layerName: string;

  /**
   * SPのブレイクポイント
   */
  breakPoint: number;
}

/**
 * 実行クラス
 */
class HeaderObject {
  /**
   * オプション
   */
  private readonly option: HeaderOption;

  /**
   * 要素オブジェクト
   */
  private readonly el: any;

  /**
   * 状態オブジェクト
   */
  private readonly state: any;

  /**
   * コンストラクタ
   * @param el 対象のJQueryオブジェクト
   * @param option オプション
   */
  constructor(el: JQuery, option: HeaderOption) {
    this.el = {};
    this.state = {};
    this.el.$root = el; // ヘッダー本体
    this.option = option;
    this.init();
  }

  /**
   * 初期設定
   */
  private init(): void {
    this.el.$win = $(window); // Windowオブジェクト
    this.el.$body = $('body'); // Bodyオブジェクト
    this.el.$content = []; // コンテンツ
    this.el.$openBtn = null; // メニュー開くボタン
    this.el.$menu = this.el.$root.find('.' + this.option.menuName); // メニュー
    this.el.$layer = null; // レイヤー
    this.state.winSize = this.getWinSize(); // Windowサイズ
    this.state.position = []; // コンテンツの位置
    this.state.isOpened = false; // メニューの開閉状態
    this.createDom(); // DOMの生成
    this.updateView(); // ビューの更新
    this.setEvent(); // イベントの設定
  }

  /**
   * Window幅の取得
   * return Window幅
   */
  private getWinSize(): {width: number, height: number} {
    return {
      width: (window.innerWidth) ? window.innerWidth : this.el.$win.width(),
      height: (window.innerHeight) ? window.innerHeight : this.el.$win.height()
    };
  }

  /**
   * ビューの状態の取得
   * @param width 判定に使用する幅の数値
   * @return 'pc'または'sp'
   */
  private getViewMode(width: number): string {
    return (width > this.option.breakPoint) ? 'pc' : 'sp';
  }

  /**
   * 各コンテンツの位置取得
   */
  private getPosition(): void {
    for (let i: number = 0; i < this.el.$content.length; i++) {
      this.state.position[i] = {
        'id': this.el.$content[i].attr('id'),
        'position': this.el.$content[i].offset()!.top
      };
    }
  }

  /**
   * DOMの生成
   */
  private createDom(): void {
    let dom: any = null;

    // 開くボタンの設置
    dom = '';
    dom += `<button class="${this.option.openBtnName}"><span></span><span></span><span></span></button>`;
    this.el.$root.append(dom);
    this.el.$openBtn = this.el.$root.children('.' + this.option.openBtnName);

    // レイヤーの設置
    dom = '';
    dom += `<div class="${this.option.layerName}"></div>`;
    this.el.$body.append(dom);
    this.el.$layer = this.el.$body.children('.' + this.option.layerName);
  }

  /**
   * ビューの更新
   */
  private updateView(): void {
    const winSize = this.getWinSize();
    const viewMode = this.getViewMode(winSize.width);
    this.state.winSize = winSize; // Window幅のstateセット

    // // モードが変わっていなければ処理しない
    if (viewMode === this.state.viewMode) {
      return;
    }

    this.state.viewMode = viewMode; // viewModeのstateセット

    if (this.state.viewMode === 'pc') {
      this.el.$openBtn.hide();
      this.el.$layer.hide();
    } else {
      this.el.$openBtn.show();
    }
  }

  /**
   * 開くイベント
   */
  private handleToggle = (event: JQueryEventObject): void => {
    if (this.el.$openBtn.hasClass('is-active')) {
      this.handleClose(event);
    } else {
      this.state.isOpened = true;
      this.el.$root.addClass('is-active');
      this.el.$openBtn.addClass('is-active');
      this.el.$menu.addClass('is-active');
      this.el.$layer.addClass('is-active');
    }
  }

  /**
   * 閉じるイベント
   */
  private handleClose = (event: JQueryEventObject): void => {
    this.state.isOpened = false;
    this.el.$root.removeClass('is-active');
    this.el.$openBtn.removeClass('is-active');
    this.el.$menu.removeClass('is-active');
    this.el.$layer.removeClass('is-active');
  }

  /**
   * イベントセット
   */
  private setEvent(): void {
    // 開くボタンのイベントセット
    this.el.$openBtn.on('click', this.handleToggle);

    // リンククリックで閉じるセット
    this.el.$menu.find('a').on('click', (event: JQueryEventObject): void => {
      if (Setting.isHeaderBreakPoint()) {
        this.handleToggle(event);
      }
    });

    // ロゴクリックで閉じるセット
    this.el.$root.find('.l-header__logo').on('click', (event: JQueryEventObject): void =>{
      if (Setting.isHeaderBreakPoint() && this.el.$menu.hasClass('is-active')) {
        this.handleClose(event);
      }
    });

    // レイヤークリックで閉じるセット
    this.el.$layer.on('click', this.handleClose);

    // リサイズイベント
    this.el.$win.on('load resize', (event: JQueryEventObject): void => {
      this.updateView();
    });
  }
}
